module.exports = __webpack_public_path__ + "static/media/4forty-white.9b61b674.svg";